import React from 'react';
import { cn } from '@/lib/utils';

export interface PlaylistGridProps {
  children: React.ReactNode;
  className?: string;
}

export function PlaylistGrid({ children, className }: PlaylistGridProps) {
  return (
    <div 
      className={cn(
        'grid',
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
        'gap-6 gap-y-6 md:gap-y-8',
        className
      )}
    >
      {children}
    </div>
  );
}
